// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d3e82f01","239":"8302f632","667":"551eae88"}[chunkId] + ".chunk.js";
};